import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { AgGridService } from '../ag-grid.service';
import { PlusIconService } from '../plus-icon/plus-icon.service';
import { CommonModule } from '@angular/common';


export interface ICustomHeaderParams {
  menuIcon: string;
  enablePlusIcon : boolean;
  isRequired:boolean;
  moreButton:boolean;
  moreaddButton:boolean;
  selectAll:boolean;
  MaterialIssue
  uploadButton:boolean;
  enablePlusIconLight:boolean;
  enableSorting:boolean;
  displayName: string;
  columnName: string;
  rows: any[];
  oldrows: any[];
  eventOccurs?: any;
  isSort: boolean;
  isFilter:boolean;
  floatingFilter:boolean;
  popUpfloatingFilter:boolean;
  floatingDropDown:boolean;
  floatingMultiselectDropDown:boolean;
  gridName:any;
  filterValueColumnName?:string;
  filterIdColumnName?:string;
  initialRows?:string;
  filterStorageName?:string;
  cellDisplayType?:string;
  isDateFilterShow?:boolean;
  isServerSidepagination?:boolean;
  tableIndex?:number;
  controllerName : string;
  isSelected : boolean;
  onCustomHeaderEvent : any;
}

@Component({
  selector: 'app-custom-header',
  templateUrl: './custom-header.component.html',
  styleUrls: ['./custom-header.component.scss']
})

export class CustomHeaderComponent implements IHeaderAngularComp {
  public params!: IHeaderParams & ICustomHeaderParams;
  public ascSort = 'inactive';
  public descSort = 'inactive';
  public noSort = 'inactive';
  @ViewChild('menuButton', { read: ElementRef }) public menuButton!: ElementRef;

  constructor(private agGridService : AgGridService,private plusIconService: PlusIconService){}


  agInit(params: IHeaderParams & ICustomHeaderParams): void {
    this.params = params;
    this.params.enableSorting;
    this.params.enablePlusIcon;
   // this.onSortChanged();
   params.column.addEventListener(
    'sortChanged',
    this.onSortChanged.bind(this)
  );

  this.onSortChanged();
  }

  onSortChanged() {
    this.ascSort = this.descSort = this.noSort = 'inactive';
    if (this.params.column.isSortAscending()) {
      this.ascSort = 'active';
    } else if (this.params.column.isSortDescending()) {
      this.descSort = 'active';
    } else {
      this.noSort = 'active';
    }
  }

  onSortRequested(event: any) {
    let order: 'asc' | 'desc' | null;
    if (this.ascSort === 'active') {
      // If ascending was active, toggle to descending
      order = 'desc';
    } else if (this.descSort === 'active') {
      // If descending was active, toggle to no sorting
      order = null;
    } else {
      // If no sorting was active or other cases, toggle to ascending
      order = 'asc';
    }
    this.params.setSort(order, event.shiftKey);
  }
  


  refresh(params: IHeaderParams) {
    return false;
  }

}